import { OrderRepository } from "../../../../data/repository/order/OrderRepository";
import { ReportRepository } from "../../../../data/repository/report/ReportRepository";
import { Order } from "../../../model/Order";
import { DateRange, GetReportRequestModel } from "../../../model/Product";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetPerProductReportUseCase {
  invoke: (model: GetReportRequestModel) => Promise<ResponseState<Blob>>;
}

export class GetPerProductReportUseCaseImpl
  implements GetPerProductReportUseCase
{
  private repository: ReportRepository;

  constructor(repository: ReportRepository) {
    this.repository = repository;
  }

  async invoke(model: GetReportRequestModel): Promise<ResponseState<Blob>> {
    try {
      let response = await this.repository.getPerProduct(model);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
